import { Component, OnInit } from "@angular/core";
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';

@Component({
  selector: "app-toolbar",
  templateUrl: "./toolbar.component.html",
  styleUrls: ["./toolbar.component.scss"]
})

export class ToolbarComponent implements OnInit {


  DISPLAY: boolean = false;
  ERROR_MESSAGES: Message[] = [];
  userform: FormGroup;
  submitted: boolean;
  description: string;
  PAYS: any[] = ['Afghanistan ', 'Afrique du Sud ', 'Albanie  ', 'Algérie ', 'Allemagne ', 'Andorre', 'Angola', 'Érythrée ', 'Espagne ', 'Estonie ', 'États-Unis ', 'Éthiopie ', 'Fidji ', 'Finlande ', 'France ', 'Gabon ', 'Gambie ', 'Géorgie ', 'Ghana ', 'Lesotho ', 'Lettonie ', 'Liban ', 'Liberia ', 'Libye ', 'Liechtenstein ', 'Lituanie ', 'Luxembourg Uruguay ', 'Vanuatu'];
  FILTER_PAYS: any[];
  SELECT_PARAM: any;
  CONTACT_TITRE = "Contacter le service commercial";
  CONTACT_NOM = "Nom";
  CONTACT_PRENOM = "Prénom";
  CONTACT_SOCIETE = "Société";
  CONTACT_EMAIL = "Email";
  CONTACT_MSG_VOTRE = "Votre message";
  CONTACT_MSG_CARACTERES_RESTANT = "caractères restants";
  CONTACT_MSG_INFORMATION_REQUISE = "Information requise";
  CONTACT_PAYS = "liste pays ";
  CONTACT_VALIDER = "Valider";

  //Resultat de la recherche  
  LABEL_RESULTATS_RECHERCHE_VERS = "Résultat vers";
  LABEL_RESULTATS_RECHERCHE_DEPUIS = "Résultat depuis";
  LABEL_RESULTATS_RECHERCHE_DIRECTION = "Vers/depuis";
  LABEL_RESULTATS_RECHERCHE_NOMBRE_SERVICES = "11 services trouvés";
  LABEL_RESULTATS_RECHERCHE_FAMILLE_TOUCHE = "";
  LABEL_RESULTATS_RECHERCHE_TYPE_TRANSPORT = "Type de transport";
  LABEL_RESULTATS_RECHERCHE_COMPAGNIE = "Compagnie";
  LABEL_RESULTATS_RECHERCHE_FREQUENCE = "Freq";
  LABEL_RESULTATS_RECHERCHE_EMPREINTE_CARBONE = "";
  LABEL_RESULTATS_MODIFIER_RECHERCHE = "";
  LABEL_RESULTATS_MODIFIER_MANUTENTIONAIRE = "";
  DETAIL_RECHERCHE_PORT_DEPART = "Marseille - Fos";
  DETAIL_RECHERCHE_PORT_ARRIVEE = "Bastia";
  DETAIL_RECHERCHE_SERVICE_LABEL = "Service ";
  DETAIL_RECHERCHE_SERVICE_RESULTAT_RECHERCHE = "Arkas Line";
  DETAIL_RECHERCHE_TYPE_TRANSPORT = "Porte conteneurs";
  DETAIL_RECHERCHE_TRANSIT_TIME_EXPORT = "Transit time export : 1j";
  DETAIL_RECHERCHE_MANUTENTIONNAIRE_LABEL = "Manutentionnaire ";
  DETAIL_RECHERCHE_MANUTENTIONNAIRE_RESULTAT_RECHERCHE = "Arkema France";
  DETAIL_RECHERCHE_FREQUENCE = "Arkema France";
  LABEL_DETAIL_RECHERCHE_FREQUENCE = "Arkema France";
  DETAIL_RECHERCHE_PROCHAINE_ESCALE = "Prochaine escale ";
  LABEL_DETAIL_RECHERCHE_PROCHAINE_ESCALE = "Prochaine escale ";
  DETAIL_RECHERCHE_FREQUENCE_RESULTAT_RECHERCHE_DETAIL = "1/7j";
  DETAIL_RECHERCHE_EMPREINTE_CARBONE_RESULTAT_RECHERCHE_DETAIL = "Empreinte carbone : 21 kg éq CO";
  DETAIL_RECHERCHE_PORT_RESULTAT_RECHERCHE_DETAIL = "Fos-sur-mer";
  DETAIL_RECHERCHE_PRCHAIN_ESCALE_RESULTAT_RECHERCHE_DETAIL = "Prochaine escale ";
  DETAIL_RECHERCHE_DATE_ESCALE_RESULTAT_RECHERCHE_DETAIL = "28/12/2018 - 20:00";
  LABEL_DETAIL_RECHERCHE_EMPREINTE_CARBONE_RESULTAT_RECHERCHE_DETAIL = "";
  LABEL_DETAIL_RESULTATS_RECHERCHE_FAMILLE_TOUCHE = "";
  COMPANIE_RESULTAT_RECHERCHE_DETAIL = "CMA-CGM";
  SITE_WEB_RESULTAT_RECHERCHE_DETAIL = "www.cma-cgm.fr";
  AGENCE_RESULTAT_RECHERCHE_DETAIL = "agence - Marseille";
  ADRESSE_RESULTAT_RECHERCHE_DETAIL = "Tour CMA CGM - 4 Quai d’Arenc, 13002 Marseille";
  SITE_WEB_RESULTAT_RECHERCHE_DETAIL_URL = "www.cma-cgm.com/local/france";
  TELEPHONE_RESULTAT_RECHERCHE_DETAIL = "+33 4 88 91 77 00";
  EMAIL_WEB_RESULTAT_RECHERCHE_DETAIL = "bod.agence@cma-cgm.com";
  DETAIL_RECHERCHE_ADRESSE_RESULTAT = "";
  DETAIL_RESULTATS_RECHERCHE_NOMBRE_SERVICE = "";



  showDialog() {
    this.DISPLAY = true;
  }



  hidDialog() {
    this.DISPLAY = false;
  }


  constructor(private fb: FormBuilder) { }


  filterPAYS(event) {
    this.FILTER_PAYS = [];
    for (let i = 0; i < this.PAYS.length; i++) {
      let SELECT_PARAM = this.PAYS[i];
      if (SELECT_PARAM.toLowerCase().indexOf(event.query.toLowerCase()) == 0) {
        this.FILTER_PAYS.push(SELECT_PARAM);
      }
    }
  }

  ngOnInit() {


    this.userform = this.fb.group({
      'NOM': new FormControl(''),
      'PRENOM': new FormControl(''),
      'SOCIETE': new FormControl(''),
      'EMAIL': new FormControl('', Validators.pattern("[^ @]*@[^ @]*")),
      'PAYS': new FormControl(''),
      'MESSAGE': new FormControl('', Validators.required)
    });

  }


  onSubmit(value: string) {
    this.submitted = true;
    this.ERROR_MESSAGES = [];
    this.ERROR_MESSAGES.push({ severity: 'info', summary: 'Success', detail: 'Form Submitted' });
  }

  get diagnostic() { return JSON.stringify(this.userform.value); }


}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/toolbar/toolbar.component.ts